/**
 * SignupChoice - "which kind of account do you want?"
 * ---------------------------------------------------
 * The two account types work very differently, so we ask up front rather than
 * hiding it in a dropdown on one long form.
 */

import { Link } from 'react-router-dom';

import { useI18n } from '../hooks/useI18n';
import { useFeatures } from '../hooks/useFeatures';
import { GraduationCap, Home, ArrowRight } from 'lucide-react';

export default function SignupChoice() {
  const { t } = useI18n();
  const { offersEnabled } = useFeatures();
  return (
    <div className="container section">
      <div className="page-header text-center">
        <h1>{t('signupChoice.title')}</h1>
        <p style={{ marginInline: 'auto' }}>
          {t('signupChoice.subtitle')}
        </p>
      </div>

      {/* `choice-cards` makes both cards the same height and pins each
          button to the bottom. Without it the buttons sit wherever the
          paragraph above them happens to end, so the one with the shorter
          sentence floats higher - and which one that is changes with the
          language, which is exactly the kind of thing nobody notices until
          the site is bilingual. */}
      <div className="grid-2 choice-cards" style={{ maxWidth: 820, margin: '0 auto' }}>
        <div className="card card-hover">
          <span className="feature-icon blue">
            <GraduationCap size={26} aria-hidden="true" />
          </span>
          <h3>{t('signupChoice.studentTitle')}</h3>
          <p className="text-muted" style={{ marginBottom: 'var(--space-sm)' }}>
            {/* "...and say when you are free" is the offers half. Offers were
                archived on 17 October 2026, so it is only said while they
                are switched on - a signup page must not promise a student
                something the site no longer does. */}
            {offersEnabled ? t('signupChoice.studentBody') : t('signupChoice.studentBodyNoOffers')}
          </p>
          <Link to="/signup/student" className="btn btn-secondary btn-block">
            {t('signupChoice.studentCta')} <ArrowRight size={16} />
          </Link>
        </div>

        <div className="card card-hover">
          <span className="feature-icon">
            <Home size={26} aria-hidden="true" />
          </span>
          <h3>{t('signupChoice.posterTitle')}</h3>
          <p className="text-muted" style={{ marginBottom: 'var(--space-sm)' }}>
            {t('signupChoice.posterBody')}
          </p>
          <Link to="/signup/user" className="btn btn-primary btn-block">
            {t('signupChoice.posterCta')} <ArrowRight size={16} />
          </Link>
        </div>
      </div>

      <p className="text-center text-sm text-muted" style={{ marginTop: 'var(--space-md)' }}>
        {t('signupChoice.haveAccount')} <Link to="/login">{t('nav.logIn')}</Link>
      </p>
    </div>
  );
}
